import { render, staticRenderFns } from "./policeList.vue?vue&type=template&id=7f4f40ad&scoped=true&"
import script from "./policeList.vue?vue&type=script&lang=js&"
export * from "./policeList.vue?vue&type=script&lang=js&"
import style0 from "./policeList.vue?vue&type=style&index=0&id=7f4f40ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4f40ad",
  null
  
)

export default component.exports